// CQL string literals are double-quoted, so a quote or a backslash typed into a filter field
// would terminate the literal and make the backend reject the whole query with a 400.
export var escapeCqlTerm = function (term) { return term.replace(/(["\\])/g, "\\$1"); };
export var contains = function (index, term) {
    return "".concat(index, "==\"*").concat(escapeCqlTerm(term), "*\"");
};
export var equals = function (index, term) {
    return "".concat(index, "==\"").concat(escapeCqlTerm(term), "\"");
};
export var anyOf = function () {
    var clauses = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        clauses[_i] = arguments[_i];
    }
    return "(".concat(clauses.join(" or "), ")");
};
export var allOf = function (clauses) { return clauses.join(" and "); };
